import { render, staticRenderFns } from "./CustomerFeedback.vue?vue&type=template&id=45e0240e&scoped=true&"
import script from "./CustomerFeedback.vue?vue&type=script&lang=ts&"
export * from "./CustomerFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerFeedback.vue?vue&type=style&index=0&id=45e0240e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0240e",
  null
  
)

export default component.exports